import React, { PureComponent } from 'react';
import ClientModal from '../../Trades/TradeDetails/ClientModal';
import Modal from '../../../../components/Modal';
import { Form, FormGroup, SubmitButton } from '../../../../components/Forms/Forms';
import { Input, Textarea, Select } from '../../../../components/Forms/fields/index';
import rules from "../../../../components/Forms/rules";

const boolean = (val)=> val === true ? 'Yes' : 'No';
const USD = (val)=> parseFloat(val).toLocaleString('en-US', { style: 'currency', currency: 'USD' });
class OfferDetailsView extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      useLivePrice: false,
    };
  }
  render() {
    const {
      clientModalActiveUsername,
      toggleClientModal,
      onClose,
      formState,
      submitForm,
      onFormUpdate,
      offers,
      liveBtcPrice,
      cachedBtcPrice,
      matchPrice,
      undercut,
    } = this.props;

    const useLivePrice = this.state.useLivePrice || !cachedBtcPrice
    const btcPrice = useLivePrice ? liveBtcPrice : cachedBtcPrice;
    return (
      <Modal className="modal-container" active onClose={() => onClose()}>
        <h2>Offer Details</h2>
        <div className="offer-details">
          <div className="offer-edit-form">
            {liveBtcPrice ? (
              <Form state={formState} onSubmit={submitForm} onChange={onFormUpdate}>
                <button role="submit" className="button">Save</button>
                <FormGroup name="margin">
                  <label>Margin</label>
                  <Input name="margin" type="text" validate={[rules.required()]}/>
                </FormGroup>
                <div>
                  <label>USD/BTC</label>
                  {USD(liveBtcPrice * (formState.data.margin / 100 + 1))}
                </div>
                <FormGroup name="offer_hash">
                  <label>Offer Hash</label>
                  <Input name="offer_hash" type="text" disabled/>
                </FormGroup>
                <FormGroup name="currency">
                  <label>Currency</label>
                  <Input name="currency" type="text" disabled/>
                </FormGroup>
                <FormGroup name="payment_method">
                  <label>Payment Method</label>
                  <Input name="payment_method" type="text" disabled/>
                </FormGroup>
                <FormGroup name="range_min">
                  <label>Range Min</label>
                  <Input name="range_min" type="text" disabled/>
                </FormGroup>
                <FormGroup name="range_max">
                  <label>Range Max</label>
                  <Input name="range_max" type="text" disabled/>
                </FormGroup>
                {/*<FormGroup name="payment_window">
                  <label>Payment Window</label>
                  <Input name="payment_window" type="text" disabled/>
                </FormGroup>*/}
                <FormGroup name="payment_method_span">
                  <label>Payment Method Label</label>
                  <Input name="payment_method_span" type="text" disabled/>
                </FormGroup>
                {/*<FormGroup name="payment_method_group">
                  <label>Payment Method Group</label>
                  <Input name="payment_method_group" type="text" disabled/>
                </FormGroup>*/}
                <FormGroup name="offer_terms">
                  <label>Offer Terms</label>
                  <Textarea name="offer_terms" type="text" disabled/>
                </FormGroup>
                {/*<FormGroup name="trade_details">
                  <label>Trade Details</label>
                  <Input name="trade_details" type="text" disabled/>
                </FormGroup>*/}
                <FormGroup name="require_verified_email">
                  <label>
                    <Input name="require_verified_email" type="checkbox" disabled />
                    Require Verified Email
                  </label>
                </FormGroup>
                <FormGroup name="require_verified_phone">
                  <label>
                    <Input name="require_verified_phone" type="checkbox" disabled />
                    Require Verified Phone
                  </label>
                </FormGroup>
                <FormGroup name="require_min_past_trades">
                  <label>Require Min Past Trades</label>
                  <Input name="require_min_past_trades" type="number" disabled/>
                </FormGroup>
                <FormGroup name="show_only_trusted_user">
                  <label>
                    <Input name="show_only_trusted_user" type="checkbox" disabled />
                    Show Only Trusted User
                  </label>
                </FormGroup>
                <FormGroup name="predefined_amount">
                  <label>Predefined Amount</label>
                  <Input name="predefined_amount" type="text" disabled/>
                </FormGroup>
                <button role="submit" className="button">Save</button>
              </Form>
            ) : (
              <div>loading...</div>
            )}
          </div>
          <div className="offer-list">
            <h2>Top Offers</h2>
            <p>BTC price {USD(liveBtcPrice)} (Live) / {USD(cachedBtcPrice)} (Cached)</p>


            {clientModalActiveUsername && (
              <ClientModal
                toggleClientModal={toggleClientModal}
                username={clientModalActiveUsername}
              />
            )}
            {useLivePrice ? (
              <button className="button"
                      disabled={!cachedBtcPrice}
                      onClick={()=>this.setState({useLivePrice: false})}
              >Use Cached Price</button>
            ) : (
              <button className="button"
                      onClick={()=>this.setState({useLivePrice: true})}
              >Use Live Price</button>
            )}
            {offers ? (
              <table>
                <thead>
                <tr>
                  <th></th>
                  <th>Seller</th>
                  <th>$/BTC</th>
                  <th>Margin</th>
                  <th>Min</th>
                  <th>Max</th>
                  <th>actions</th>
                </tr>
                </thead>
                <tbody>
                {offers.map((offer, i)=>{
                  const margin = ((offer.fiat_price_per_btc / btcPrice) - 1) * 100;
                  const formattedMargin = Math.round(margin * 100) / 100;
                  return (
                    <tr key={i}>
                      <td></td>
                      <td>
                        <div className="cell-username">

                          <a
                            href={offer.offer_owner_profile_link}
                            onClick={(e) => {
                              e.preventDefault();
                              toggleClientModal(offer.offer_owner_username);
                            }}
                          >{offer.offer_owner_username}</a>
                          {offer.offer_owner_feedback_positive ? (
                            <span className="feedback-positive">+{offer.offer_owner_feedback_positive}</span>
                          ) : null}
                          {offer.offer_owner_feedback_negative ? (
                            <span className="feedback-negative">-{offer.offer_owner_feedback_negative}</span>
                          ) : null}
                        </div>
                      </td>
                      <td><a href={offer.offer_link}>{USD(offer.fiat_price_per_btc)}</a></td>
                      <td>{formattedMargin}</td>
                      <td>{offer.fiat_amount_range_min}</td>
                      <td>{offer.fiat_amount_range_max}</td>
                      <td>
                        <div className="action-buttons">
                          <button onClick={()=>undercut(margin)}>Undercut</button>
                          <button onClick={()=>matchPrice(margin)}>Match</button>
                        </div>
                      </td>
                    </tr>
                  );
                })}
                </tbody>
              </table>
            ) : (
              <div>loading...</div>
            )}

          </div>
        </div>

      </Modal>
    )
  }
}

export default OfferDetailsView;



// WEBPACK FOOTER //
// ./src/app/modules/WorkArea/Offers/OfferDetails/OfferDetails.view.js